import { useEffect, useState } from 'react';

/** A search box's value once the typing has stopped, so a server-paginated table is not queried per key. */
export const useDebouncedValue = <TValue>(value: TValue, delayMs = 300): TValue => {
  const [debounced, setDebounced] = useState<TValue>(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);

    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};
